import { render } from "./EmployeeViewPR.vue?vue&type=template&id=689871d6"
import script from "./EmployeeViewPR.vue?vue&type=script&lang=js"
export * from "./EmployeeViewPR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__